import React from 'react';

import { useMsgContext } from '../msg-context';
import { Wrapper } from 'widget/components';

import MsgButton from './msg-button/msg-button';

const Buttons = () => {
  const { msg } = useMsgContext();

  return (
    <>
      {msg.buttons && (
        <Wrapper flexWrap="wrap" gap={8} justifyContent="flex-end">
          {msg.buttons.map((button, i) => (
            <MsgButton button={button} key={i} />
          ))}
        </Wrapper>
      )}
    </>
  );
};

export default Buttons;
